module.exports = __webpack_public_path__ + "static/media/gam-min.b2526f15.png";